export default class CrossWord {
    constructor() {
        this.title = localStorage.getItem("title");
        this.terms = localStorage.getItem("terms").split("\n");
        this.sortedTerms = localStorage.getItem("terms").split("\n").sort(function (a, b) {
            return b.length - a.length;
        });
        this.definitions = localStorage.getItem("definitions").split("\n");
        this.across = [];
        this.down = [];
        this.grid = [];
        this.crossGrid = [];
        this.size = this.sortedTerms[0] ? this.sortedTerms[0].length : 1;
        this.intersections = 0;
        this.placedTerms = 0;

        this.attempts = 0;
        this.ATTEMPTSMAX = 50;
        for (let i = 0; i < this.size; i++) {
            this.grid[i] = [];
            this.crossGrid[i] = [];
            for (let j = 0; j < this.size; j++) {
                this.grid[i][j] = '';
                this.crossGrid[i][j] = '';
            }
        }

        while (this.attempts < this.ATTEMPTSMAX && (!this.placeTerms() || this.intersections < this.terms.length - 1)) {
            this.size++;
            this.attempts++;
            this.reset();
        }
    }
    placeTerms() {
        var location;
        for (var i = 0; i < this.terms.length; i++) {
            location = this.getRandomLocation(this.terms[i], this.grid);
            if (location) {
                if (location[3]) {
                    this.across.push(this.definitions[i]);
                    this.crossGrid[location[0]][location[1]] = this.across.length;
                } else {
                    this.down.push(this.definitions[i]);
                    this.crossGrid[location[0]][location[1]] = this.down.length;
                }
                for (var j = 0; j < this.terms[i].length; j++) {
                    this.grid[location[0] + j * location[2]][location[1] + j * location[3]] = this.terms[i].charAt(j);
                }
                this.placedTerms++;
            } else if (this.attempts < this.ATTEMPTSMAX) {
                return false;
            }
        }
        return true;
    };
    getRandomLocation(term) {
        /* Only returns valid locations for the term */
        var locations = [];
        var valid = false;
        var directions = [[1, 0], [0, 1]];
        var dx,
            dy;
        var intersections;
        for (var i = 0; i < this.size; i++) {
            for (var j = 0; j < this.size; j++) {
                for (var k = 0; k < directions.length; k++) {
                    dx = directions[k][0];
                    dy = directions[k][1];
                    intersections = 0;
                    if (i + dx * term.length >= 0 && j + dy * term.length >= 0 && i + dx * term.length + Math.floor(j % 2) < this.size && j + dy * term.length < this.size) {
                        if (j % 2 == 0 || i < this.size - 1) {
                            valid = true;
                            for (var l = 0; l < term.length; l++) {
                                if (this.grid[i + l * dx][j + l * dy])
                                    if (this.grid[i + l * dx][j + l * dy] != term.charAt(l)) {
                                        valid = false;
                                        break;
                                    } else
                                        intersections++;
                                else {
                                    if (dx) {
                                        if ((this.grid[i + l * dx][j + 1]) || (j > 0 && this.grid[i + l * dx][j - 1])) {
                                            valid = false;
                                            break;
                                        }
                                    } else {
                                        if ((i + 1 < this.size && this.grid[i + 1][j + l * dy]) || (i > 0 && this.grid[i - 1][j + l * dy])) {
                                            valid = false;
                                            break;
                                        }
                                    }
                                }
                            }
                            if (dx) {
                                if ((i > 0 && this.grid[i - 1][j]) || (i + term.length < this.size && this.grid[i + term.length][j]))
                                    valid = false;
                                else if (this.crossGrid[i][j] && this.down.length != this.across.length - 1)
                                    valid = false;
                            } else {
                                if ((j > 0 && this.grid[i][j - 1]) || (j + term.length < this.size && this.grid[i][j + term.length]))
                                    valid = false;
                                else if (this.crossGrid[i][j] && this.across.length != this.down.length - 1)
                                    valid = false;
                            }
                            if (intersections == 0 && this.placedTerms > 0)
                                valid = false;
                            if (valid)
                                locations.push([i, j, dx, dy, intersections]);
                        }
                    }
                }
            }
        }
        locations.sort(function (a, b) {
            return b[4] - a[4];
        });
        for (var i = 0; i < locations.length; i++)
            if (locations[i][4] < locations[0][4]) {
                locations.splice(i, 1);
                i--;
            }
        var target = locations[Math.floor(Math.random() * locations.length)];
        if (target && target[4] > 0)
            this.intersections += target[4];
        return target;
    };
    reset() {
        this.grid = [];
        this.crossGrid = [];
        for (let i = 0; i < this.size; i++) {
            this.grid[i] = [];
            this.crossGrid[i] = [];
            for (let j = 0; j < this.size; j++) {
                this.grid[i][j] = '';
                this.crossGrid[i][j] = '';
            }
        }
        this.across = [];
        this.down = [];
        this.intersections = 0;
        this.placedTerms = 0;
    };
    create(worksheet) {
        // Create title
        var title = document.createElement("h4");
        title.className = 'text-center';
        title.innerHTML = this.title;
        worksheet.appendChild(title);

        // Remove empty rows from the start and end of the crossword grids
        this.removeEmptyRowsAndColumns();
        this.size = Math.max(this.grid.length, this.grid[0].length);

        // Create cross word box
        for (var i = 0; i < this.grid.length; i++) {
            var row = document.createElement("div");
            row.style.height = Math.floor(720 / (this.size + 1)) + "px";
            for (var j = 0; j < this.grid[i].length; j++) {
                var div = document.createElement("div");
                div.style.width = Math.floor(720 / (this.size + 1)) + "px";
                div.style.height = Math.floor(720 / (this.size + 1)) + "px";
                div.className = "square";
                if (this.grid[i][j]) {
                    div.className = "square justify-content-center border border-dark";
                    if (this.grid[i][j] != " ") {
                        let text = document.createElement('div');
                        text.className = 'd-print-none';
                        text.innerHTML = this.grid[i][j];
                        div.appendChild(text);
                        if (this.crossGrid[i][j]) {
                            let text = document.createElement('div');
                            text.style.position = 'absolute';
                            text.style.fontWeight = 'bold';
                            text.style.left = 0;
                            text.style.top = 0;
                            text.innerHTML = this.crossGrid[i][j];
                            div.appendChild(text);
                        }
                    } else {
                        let line1 = document.createElement('div');
                        line1.className = 'line1';
                        let line2 = document.createElement('div');
                        line2.className = 'line2';
                        div.appendChild(line1);
                        div.appendChild(line2);
                    }
                }
                row.appendChild(div);
            }
            worksheet.appendChild(row);
        }

        let hr = document.createElement('hr');
        worksheet.appendChild(hr);

        var bank = document.createElement("div");
        bank.className = "row";
        var across = document.createElement("div");
        across.className = "col-md-6 d-block";
        var acrossTitle = document.createElement("h5");
        acrossTitle.innerHTML = "Across Hints";
        across.appendChild(acrossTitle);
        for (var i = 0; i < this.across.length; i++) {
            var p = document.createElement("div");
            p.innerHTML = (i + 1) + ". " + this.across[i];
            across.append(p);
            renderMathInElement(p);
        }
        bank.appendChild(across);
        var down = document.createElement("div");
        down.className = "col-md-6 d-block";
        var downTitle = document.createElement("h5");
        downTitle.innerHTML = "Down Hints";
        down.appendChild(downTitle);
        for (var i = 0; i < this.down.length; i++) {
            var p = document.createElement("div");
            p.innerHTML = (i + 1) + ". " + this.down[i];
            down.append(p);
            renderMathInElement(p);
        }
        bank.appendChild(down);
        worksheet.appendChild(bank);
    };
    removeEmptyRowsAndColumns() {
        // Remove empty rows from the beginning
        let rows = this.grid.length;
        if (rows) {
            for (let i = 0; i < rows; i++) {
                let empty = true;
                for (let j = 0; j < this.grid[i].length; j++) {
                    if (this.grid[i][j]) {
                        empty = false;
                        i = rows;
                        break;
                    }
                }
                if (empty) {
                    this.grid.splice(i, 1);
                    this.crossGrid.splice(i, 1);
                    i--;
                    rows--;
                }
            }

            // Remove empty rows from the end
            for (let i = this.grid.length - 1; i >= 0; i--) {
                let empty = true;
                for (let j = 0; j < this.grid[i].length; j++) {
                    if (this.grid[i][j]) {
                        empty = false;
                        i = -1;
                        break;
                    }
                }
                if (empty) {
                    this.grid.splice(i, 1);
                    this.crossGrid.splice(i, 1);
                }
            }


            // Remove empty columns from the beginning
            // ith column, jth row
            let cols = this.grid[0].length;
            for (let i = 0; i < cols; i++) {
                let empty = true;
                for (let j = 0; j < this.grid.length; j++) {
                    if (this.grid[j][i]) {
                        empty = false;
                        i = cols;
                        break;
                    }
                }
                if (empty) {
                    for (let j = 0; j < this.grid.length; j++) {
                        this.grid[j].splice(i, 1);
                        this.crossGrid[j].splice(i, 1);
                    }
                    i--;
                    cols--;
                }
            }

            // Remove empty columns from the end
            // ith column, jth row
            for (let i = this.grid[0].length; i >= 0; i--) {
                let empty = true;
                for (let j = 0; j < this.grid.length; j++) {
                    if (this.grid[j][i]) {
                        empty = false;
                        i = -1;
                        break;
                    }
                }
                if (empty) {
                    for (let j = 0; j < this.grid.length; j++) {
                        this.grid[j].splice(i, 1);
                        this.crossGrid[j].splice(i, 1);
                    }
                }
            }
        }
    }
}